import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
// import {Container, Row, Col} from 'reactstrap'
import {send} from '../../modules/media'
import {Link} from 'react-router-dom'
import {withRouter} from 'react-router'
import Dropzone from 'react-dropzone'
// import APIRequest from '../../helpers/APIRequest'
import {getVisibleProjects} from '../../modules/projects'
import {getAllProjects} from '../../modules/projects'
import {getFormula} from '../../helpers/lib'

import './project.css'

import DownloadIcon from 'react-icons/lib/fa/cloud-download'
import SpinnerIcon from 'react-icons/lib/fa/spinner'
import SadIcon from 'react-icons/lib/fa/frown-o'
import CheckIcon from 'react-icons/lib/fa/check'
import {Table} from 'reactstrap'

class Structures extends Component {

  componentWillMount() {
    this.props.getAllProjects();
    this.interval = setInterval(function() {
      if (this.props) {
        this.props.getAllProjects();
      }
    }, 5000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {
    const projects = this.props.projects;
    const props = this.props;
    return (<div>
      <ol className="breadcrumb bg-gray-600 m-0 align-items-center">
        <li className="breadcrumb-item active">
          Projects
        </li>

        {/*}<li className="breadcrumb-menu d-md-down-none">
          <div className="btn-group" role="group" aria-label="Button group">
            <a className="btn" href="/ok">
          <i className="icon-speech"></i>
            </a>
          </div>
        </li>*/}
        
      </ol>
      <div className="card m-0 border-0">
        <div className="card-body">
          <h4 className="card-title mb-3">List of your project {
              projects && projects.length
                ? `(${projects.length})`
                : null
          }</h4>

          <div className="card text-center">
            <form className="card-body bg-gray-100">
              {
                  props.isSendingFile
                    ? <div className="dropzone">
                      <p className="text-warning mb-0"><SpinnerIcon className="fa-pulse" height="3em" width="3em"/>&nbsp;
                      File is dowloading...</p>
                    </div>
                    : !props.isSendingCompleted
                      ? <Dropzone className="dropzone" onDrop={props.send}>
                        <p className="text-gray-400 mb-0"><DownloadIcon height="3em" width="3em"/>&nbsp;
                          Drag <b>or choose an CIF file</b>&nbsp;
                        to create a new project.</p>
                      </Dropzone>
                      : props.isSendingWasSucessfull
                        ? <Dropzone className="dropzone" onDrop={props.send}>
                          <p className="text-success"><CheckIcon height="3em" width="3em"/>&nbsp;
                          Download successfull !</p>
                          <p className="text-gray-400 mb-0">You can add <b>another valid CIF file</b>&nbsp;
                          to create a another project.</p>
                        </Dropzone>
                        : <Dropzone className="dropzone" onDrop={props.send}>
                          <p className="text-danger"><SadIcon height="3em" width="3em"/> {props.errors}</p>
                          <p className="text-gray-400 mb-0">Retry by dragging <b>a valid CIF file</b> to create a new project.</p>
                        </Dropzone>
              }
            </form>
          </div>

          <Table className="bg-white border">
            <thead className="bg-light text-gray-600">
              <tr>
                <th>#</th>
                <th>Project</th>
                <th>Structures</th>
              </tr>
            </thead>
            <tbody>
              {
                projects.sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                }).map((project, index) => (<tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>
                    <Link to={`/projects/${project._id}`}>
                      <strong>{project.name}</strong>
                    </Link>
                  </td>
                  <td>{
                    project.structures
                      ? <div>
                        <ul className="list-unstyled list-inline mb-0">
                          {
                            project.structures && project.structures.map((structure, index) => <li className="list-inline-item" key={index}>
                              {
                                structure.relaxedStructure
                                  ? <Link to={`/projects/${project._id}/structures/${structure._id}`}>{structure.name}</Link>
                                  : <span>{getFormula(structure.name)}</span>
                              }
                            </li>)
                          }
                        </ul>
                      </div>
                      : null
                  }</td>
                </tr>))
              }
            </tbody>
          </Table>
        </div>
      </div>

      {/* <Row className="row-pad">
          {projects.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        }).map((project, index) => (
          <Col key={index} className="col-4">
          <div className="card project">
          <div className="card-body">
          <h4 className="card-title">
          <Link to={`/projects/${project._id}`}>{getFormula(project.name)}</Link>
        </h4>
        {project.structures ?
        <div>
        {project.structures.length} structures:
        <ul className="list-unstyled">
        {project.structures && project.structures.map((structure, index) =>
        <li key={index}>
        {structure.relaxedStructure ?
        <Link to={`/projects/${project._id}/structures/${structure._id}`}>{structure.name}</Link> :
        <span>{structure.name}</span>
        }
        </li>
        )}
        </ul>
        </div>
        : null }

        </div>
        </div>
        </Col>
        ))}
          </Row> */
      }
    </div>)
  }
}

const mapStateToProps = state => ({
  ...state.media,
  projects: getVisibleProjects(state.projects),
  isSendingFile: state.media.isSendingFile
})

const mapDispatchToProps = dispatch => bindActionCreators({
  send,
  getAllProjects
}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Structures))



// WEBPACK FOOTER //
// ./src/containers/project/projects.js